<crm-contact-association-panel [id]="id" [name]="name" [objectType]="'Company'"> </crm-contact-association-panel>
